import { render, staticRenderFns } from "./PlvLiveLogin.vue?vue&type=template&id=ba01a734&scoped=true&"
import script from "@/scripts/PlvLiveLogin/index.js?vue&type=script&lang=js&"
export * from "@/scripts/PlvLiveLogin/index.js?vue&type=script&lang=js&"
import style0 from "./PlvLiveLogin.vue?vue&type=style&index=0&id=ba01a734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba01a734",
  null
  
)

export default component.exports